export default __webpack_public_path__ + "static/media/landingPage_1.1f9aca89.jpg";